/**
 * 本地调试配置文件
 * 
 * 使用说明：
 * 1. 本地开发时，将 ENABLE_LOCAL_DEBUG 设置为 true
 * 2. 填写下方的调试参数（从企业微信环境中获取）
 * 3. 项目启动后会跳过企业微信SDK初始化，直接使用配置的参数
 * 4. 上线前请将 ENABLE_LOCAL_DEBUG 设置为 false
 */

// 是否启用本地调试模式
export const ENABLE_LOCAL_DEBUG = false

// 本地调试参数配置
export const DEBUG_CONFIG = {
  // 企业ID
  corpId: 'wwa731f1a5d453f22f',
  
  // 应用ID
  agentId: '1000010',
  
  // 服务端用户ID（客服ID）- 从 getUserId 接口获取
  serverUserId: 'ZhouRuiSheng',
  
  // 外部联系人ID（客户ID）- 从 getCurExternalContact 获取
  externalUserId: 'wmNJ7bRQAAi1knsq0N9lrJ7xGnRyccoQ',
}

/**
 * 获取调试模式状态
 * 优先级：URL参数 > 配置文件
 * URL添加 ?debug=true 可临时开启调试模式
 * URL添加 ?debug=false 可临时关闭调试模式
 */
export function isDebugMode() {
  // 检查URL参数
  const urlParams = new URLSearchParams(window.location.search)
  const debugParam = urlParams.get('debug')
  
  if (debugParam === 'true') {
    return true
  }
  if (debugParam === 'false') {
    return false
  }
  
  // 使用配置文件设置
  return ENABLE_LOCAL_DEBUG
}

/**
 * 获取调试配置
 */
export function getDebugConfig() {
  return DEBUG_CONFIG
}
